export default __webpack_public_path__ + "static/media/spinner-blue.e0514055.svg";